import { NavigationItem } from 'app/core/navigation/navigation.types';
import { PermissionScopes, PermissionModelTypes } from '@twrx-api-models';
import {
	CustomerRoutes,
	LineOfBusinessRoutes,
	PayorRoutes,
	RebateAggregatorRoutes,
	RebatesLoadRoutes,
	RebatesUpdateRoutes,
	ReportRoutes,
	UserRoutes,
	BdcRoutes,
	CustomerMonthlyDataRoutes,
	NdcReplacementMappingsRoutes,
	DownstreamClientIdAssociationRoutes,
	SubmissionPeriodRoutes,
	RebateAggregatorNdcRateRoutes,
	AberrantQuantityRoutes,
	UnbreakableQuantityRoutes,
	RebateGroupRoutes,
	ExcludedPharmacyRoutes,
	FormularyNdcRoutes,
	InOutpatientDefinitionRoutes,
	NonPatientExclusionRoutes,
	AuditEventsRoutes,
	RebatesReSubmissionRoutes,
	ProcessingConfigRoutes,
	RebateGroupAggregatorNdcRoutes,
	SubmissionFilesRoutes,
	SubmissionOverviewRoutes
} from 'app/common/routes';

export const defaultNavigation: NavigationItem[] = [
	{
		id:    'SubmissionOverview',
		label: 'Submission Overview',
		icon:  'fa-table',
		route: `${SubmissionOverviewRoutes.Root}`,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.SubmissionOverview,
					permission: PermissionModelTypes.Execute
				}
			]
		}
	},
	{
		id:    'CustomerMonthlyData',
		label: 'Rebate Planning',
		icon:  'fa-chart-pie',
		route: `${CustomerMonthlyDataRoutes.Root}`,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.CustomerMonthlyData,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'Reports',
		label: 'Reports',
		icon:  'fa-file-lines',
		route: `${ReportRoutes.Root}`,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.Report,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'SubmissionFiles',
		label: 'Submission Files',
		icon:  'fa-file-export',
		route: `${SubmissionFilesRoutes.Root}`,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.SubmissionFiles,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'RebatesLoad',
		label: 'File Processing',
		icon:  'fa-arrow-up-from-bracket',
		route: RebatesLoadRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.RebatesLoad,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'RebatesUpdate',
		label: 'Rebates Update',
		icon:  'fa-pen-to-square',
		route: RebatesUpdateRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.RebatesUpdate,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'RebatesReSubmission',
		label: 'Re-Submission',
		icon:  'fa-share-from-square',
		route: RebatesReSubmissionRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.RebatesReSubmission,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'Customers',
		label: 'Customers',
		icon:  'fa-id-card',
		route: CustomerRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.Customers,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'Payor',
		label: 'Payors',
		icon:  'fa-credit-card',
		route: PayorRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.Payor,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:    'InOutpatientDefinition',
		label: 'I/O Patient Definitions',
		icon:  'fa-house-medical',
		route: InOutpatientDefinitionRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.InOutpatientDefinition,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:       'RebateEligible',
		label:    'Rebate Eligible',
		icon:     'fa-arrow-up-from-bracket',
		children: [
			{
				id:    'RebateAggregatorNdcRates',
				label: 'NDC Rates',
				route: RebateAggregatorNdcRateRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.RebateAggregatorNdcRates,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'FormularyNdc',
				label: 'Formulary NDC',
				route: FormularyNdcRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.FormularyNdc,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'DownstreamClientId',
				label: 'Group ID',
				route: DownstreamClientIdAssociationRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.DownstreamClientIdAssociation,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'RebateGroupAggregatorNdc',
				label: 'NDC Destinations',
				route: RebateGroupAggregatorNdcRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.RebateGroupAggregatorNdc,
							permission: PermissionModelTypes.Read
						}
					]
				}
			}
		]
	},
	{
		id:    'AberrantQuantities',
		label: 'Aberrant Quantities',
		icon:  'fa-list-check',
		route: AberrantQuantityRoutes.Root,
		meta:  {
			allowedPermissions: [
				{
					scope:      PermissionScopes.AberrantQuantity,
					permission: PermissionModelTypes.Read
				}
			]
		}
	},
	{
		id:       'AdminSettings',
		label:    'Admin',
		icon:     'fa-gear',
		children: [
			{
				id:    'LineOfBusiness',
				label: 'Line of Business',
				route: LineOfBusinessRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.LineOfBusiness,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'Bdc',
				label: 'Third Party Setup',
				route: BdcRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.ThirdParty,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'NdcReplacementMappings',
				label: 'NDC Replacement Mappings',
				route: NdcReplacementMappingsRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.NdcReplacementMappings,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'Users',
				label: 'Users',
				route: `${UserRoutes.Root}/${UserRoutes.Users}`,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.Users,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'Roles',
				label: 'Roles',
				route: `${UserRoutes.Root}/${UserRoutes.Roles}`,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.Roles,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'SubmissionPeriods',
				label: 'Submission Periods',
				route: SubmissionPeriodRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.SubmissionPeriod,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'ProcessingConfig',
				label: 'File Processing Setup',
				route: ProcessingConfigRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.ProcessingConfig,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'UnbreakableQuantities',
				label: 'Unbreakable Quantities',
				route: UnbreakableQuantityRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.UnbreakableQuantity,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'RebateGroups',
				label: 'Rebate Groups',
				route: RebateGroupRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.RebateGroup,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'ExcludedPharmacy',
				label: 'Excluded Pharmacies',
				route: ExcludedPharmacyRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.ExcludedPharmacy,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'RebateAggregators',
				label: 'Rebate Aggregators',
				route: RebateAggregatorRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.RebateAggregators,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'NonPatientExclusion',
				label: 'Non-Patient Exclusions',
				route: NonPatientExclusionRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.NonPatientExclusion,
							permission: PermissionModelTypes.Read
						}
					]
				}
			},
			{
				id:    'AuditEvents',
				label: 'Audit History',
				route: AuditEventsRoutes.Root,
				meta:  {
					allowedPermissions: [
						{
							scope:      PermissionScopes.AuditEvents,
							permission: PermissionModelTypes.Read
						}
					]
				}
			}
		]
	}
];
